import { LoadUserSpecies } from "../../domain/use-case/LoadUserSpecies";
import api from "../../services/api";

export class RemoteLoadUserSpecies implements LoadUserSpecies {
  async handle (params: LoadUserSpecies.Params): Promise<any> {
    const response = await api.get(`/species/${params.userId}`)
    return response.data
  }
}